module.exports = __webpack_public_path__ + "img/A1_HQ01.91420acd.jpg";